import React from 'react';
import triadImg from '../../../assets/img/cia_triad.jpg';
import integrityImg from '../../../assets/img/file-integrity-monitoring.jpg';
import googlePrivacy from '../../../assets/img/google_privacy.jpg';
import haMeme from '../../../assets/img/ha_meme.png';

export default function CiaTriad() {
  const styles = {
    heading: {
      color: 'white',
      fontSize: '2.5em',
      marginBottom: '30px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
    },
    img: {
      width: '100%',
      maxWidth: '400px',
      height: 'auto',
      borderRadius: '15px',
      boxShadow: '0 8px 25px rgba(0,0,0,0.3)'
    },
    contentLayout: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '40px',
      marginTop: '20px',
      maxWidth: '100%',
      padding: '0 20px'
    },
    imageContainer: {
      flex: '0 0 45%',
      textAlign: 'center'
    },
    textContainer: {
      flex: '1',
      minWidth: '0'
    },
    cardTitle: {
      color: '#4ecdc4',
      fontSize: '1.8em',
      marginBottom: '20px',
      textAlign: 'center',
      fontWeight: 'bold'
    },
    conceptBox: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '15px',
      borderRadius: '8px',
      marginBottom: '15px',
      border: '1px solid rgba(78, 205, 196, 0.3)'
    },
    conceptTitle: {
      color: '#4ecdc4',
      fontSize: '1.3em',
      marginBottom: '10px',
      fontWeight: 'bold'
    },
    conceptText: {
      color: 'white',
      fontSize: '1.1em',
      lineHeight: '1.5'
    },
    examplesList: {
      listStyle: 'none',
      padding: '0',
      margin: '15px 0'
    },
    exampleItem: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      margin: '8px 0',
      padding: '12px 15px',
      borderRadius: '8px',
      border: '1px solid rgba(78, 205, 196, 0.2)',
      color: 'white',
      fontSize: '1em'
    },
    icon: {
      marginRight: '10px',
      fontSize: '1.2em'
    }
  };
  return (
    <>
      <section>
        <section data-background-color="CadetBlue">
          <h1 style={styles.heading}>Enjeux de la cybersécurité</h1>
          <img style={styles.img} src={triadImg} alt="CIA triad" />
        </section>

        <section>
          <h2 style={styles.cardTitle}>
            <span role="img" aria-label="Lock" style={styles.icon}>
              🔒
            </span>
            Confidentialité
          </h2>

          <div style={styles.contentLayout}>
            <div style={styles.imageContainer}>
              <img
                src={googlePrivacy}
                alt="Google Privacy"
                style={styles.img}
              />
            </div>
            <div style={styles.textContainer}>
              <div style={styles.conceptBox}>
                <div style={styles.conceptTitle}>Définition</div>
                <div style={styles.conceptText}>
                  Garantir que les informations ne sont accessibles qu'aux
                  personnes autorisées. Protection contre l'accès non
                  autorisé, la divulgation ou l'espionnage.
                </div>
              </div>

              <div style={styles.conceptTitle}>Moyens de protection :</div>
              <ul style={styles.examplesList}>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Shield">
                    🛡️
                  </span>
                  <strong>Chiffrement :</strong> AES-256, RSA, TLS/SSL
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Key">
                    🔑
                  </span>
                  <strong>Authentification :</strong> MFA, SSO, certificats
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Eye">
                    👁️
                  </span>
                  <strong>Contrôle d'accès :</strong> RBAC, ACL, audit logs
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Document">
                    📋
                  </span>
                  <strong>Conformité :</strong> RGPD, ISO 27001, SOC 2
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 style={styles.cardTitle}>
            <span role="img" aria-label="Check" style={styles.icon}>
              ✅
            </span>
            Intégrité
          </h2>

          <div style={styles.contentLayout}>
            <div style={styles.imageContainer}>
              <img
                src={integrityImg}
                alt="File integrity"
                style={styles.img}
              />
            </div>
            <div style={styles.textContainer}>
              <div style={styles.conceptBox}>
                <div style={styles.conceptTitle}>Définition</div>
                <div style={styles.conceptText}>
                  Garantir que les données n'ont pas été modifiées de manière
                  non autorisée. Protection contre la corruption, l'altération
                  ou la falsification des informations.
                </div>
              </div>

              <div style={styles.conceptTitle}>Moyens de protection :</div>
              <ul style={styles.examplesList}>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Fingerprint">
                    🔍
                  </span>
                  <strong>Hachage :</strong> SHA-256, MD5, checksums
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Signature">
                    ✍️
                  </span>
                  <strong>Signature numérique :</strong> Certificats, PKI
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Clock">
                    🕐
                  </span>
                  <strong>Versioning :</strong> Git, snapshots, backups
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Monitor">
                    📊
                  </span>
                  <strong>Monitoring :</strong> FIM, audit trails, logs
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 style={styles.cardTitle}>
            <span role="img" aria-label="Clock" style={styles.icon}>
              ⏰
            </span>
            Disponibilité
          </h2>

          <div style={styles.contentLayout}>
            <div style={styles.imageContainer}>
              <img
                src={haMeme}
                alt="High Availability meme"
                style={styles.img}
              />
            </div>
            <div style={styles.textContainer}>
              <div style={styles.conceptBox}>
                <div style={styles.conceptTitle}>Définition</div>
                <div style={styles.conceptText}>
                  Garantir que les systèmes et données sont accessibles quand
                  ils sont nécessaires. Protection contre les pannes, les
                  attaques DDoS et les interruptions de service.
                </div>
              </div>

              <div style={styles.conceptTitle}>Moyens de protection :</div>
              <ul style={styles.examplesList}>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Server">
                    🖥️
                  </span>
                  <strong>Redondance :</strong> Clusters, load balancing,
                  failover
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Chart">
                    📈
                  </span>
                  <strong>SLA :</strong> 99.9% (8.7h/an), 99.99% (52min/an)
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Backup">
                    💾
                  </span>
                  <strong>Backup :</strong> 3-2-1 rule, RTO/RPO, disaster
                  recovery
                </li>
                <li style={styles.exampleItem}>
                  <span role="img" aria-label="Shield">
                    🛡️
                  </span>
                  <strong>Protection :</strong> DDoS mitigation, monitoring,
                  alerting
                </li>
              </ul>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
